import { FaCheckCircle, FaDownload, FaTimesCircle } from "react-icons/fa";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { DATE_FORMAT } from "config/settings";
import { FaFileExport } from "react-icons/fa6";
import useExportApi from "./useExportApi";
import useCoreStore from "views/hooks/useCoreStore";
import TooltipButton from "views/Documents/components/TooltipButton";

const { Text } = Typography;

export default function useColumnsTable(refetch: () => void) {
  const { t } = useTranslation();

  const { handleExportPlatform } = useExportApi(refetch);
  const companyData = useCoreStore(state => state.companyData);

  const software = companyData?.settings?.software?.software?.value;

  const excludeSoftware = ["FULLL", "AZURMARIADB"];

  const showExportButton = software ? !excludeSoftware.includes(software) : false;

  const columns = [
    {
      title: t("Name"),
      dataIndex: "fileName",
      key: "fileName",
    },
    {
      title: t("Date - Time"),
      render: (_: unknown, record: Record<string, any>) => {
        return (
          <span>
            {record?.date} - {record?.time}
          </span>
        );
      },
    },
    {
      title: t("Min/Max entry date"),
      key: "minEntryDate",
      render: (_: unknown, record: Record<string, any>) => {
        return (
          <span>
            {record?.minEntryDate && dayjs(record?.minEntryDate).format(DATE_FORMAT)} -{" "}
            {record?.maxEntryDate && dayjs(record?.maxEntryDate).format(DATE_FORMAT)}
          </span>
        );
      },
    },

    {
      title: t("Total Documents"),
      dataIndex: "totalDocuments",
      key: "totalDocuments",
    },
    {
      title: t("Size"),
      dataIndex: "size",
      key: "size",
    },
    {
      title: t("Auto exported"),
      dataIndex: "autoExported",
      key: "autoExported",
      align: "center",
      render: (_: unknown, record: Record<string, any>) => {
        return record.autoExported ? (
          <Text type="success">
            <FaCheckCircle />
          </Text>
        ) : (
          <Text type="danger">
            <FaTimesCircle />
          </Text>
        );
      },
    },
    {
      title: t("Actions"),
      dataIndex: "url",
      key: "url",
      width: "100px",
      align: "center",
      render: (_: unknown, record: Record<string, any>) => {
        if (record?.canBeReexported && !record?.url && showExportButton) {
          return (
            <TooltipButton
              title={t("Reexport")}
              placement="top"
              handleOnClick={() =>
                handleExportPlatform(record?.bookEntriesSource, record?.exportId)
              }
              icon={<FaFileExport />}
            />
          );
        } else if (record?.url) {
          return (
            <TooltipButton
              title={t("Download")}
              placement="top"
              handleOnClick={() => window.open(`${record.url}&download=1`, "_blank")}
              icon={<FaDownload />}
            />
          );
        }
      },
    },
  ];

  return { columns };
}
